import React, { useState } from 'react';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  CardContent,
  Card,
  IconButton,
} from '@material-ui/core';
import { Add, Remove, OpenWith } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setMaterialsDialog } from '../redux';
import {
  deleteUsedMaterial,
  removeUsedMaterial,
  usedMaterialsListType,
  newUsedMaterialsListType,
  closedTaskUsedMaterialsListType,
} from '../../helperFunctions';
import useWindowDimensions from '../../hooks/useWindowDimensions';

export default () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);

  const showTaskDetails = useSelector(state => state.tasks.showTaskDetails);
  const endTaskDialogTaskId = useSelector(state => state.tasks.endTaskDialog.taskId);
  const taskStarted = useSelector(state => state.tasks.taskStarted);
  const materialsDialog = useSelector(state => state.tasks.materialsDialog);
  const newUsedMaterials = useSelector(state => state.tasks.newUsedMaterials);
  const closedTaskUsedMaterials = useSelector(state => state.tasks.closedTaskUsedMaterials);
  const data = useSelector(state => state.tasks.data);
  const { usedMaterials } = data;
  const task = data.tasks.find(
    x => x.id === showTaskDetails.taskId || x.id === endTaskDialogTaskId
  );
  const fontSize = width <= 500 ? '4vw' : '20px';

  return task ? (
    <Card style={{ marginTop: '3px' }}>
      <div style={{ backgroundColor: task.ticketId ? '#da291c' : '#a5daff', padding: '3px' }}>
        <Typography
          gutterBottom
          component="span"
          style={{
            fontSize,
            color: task.ticketId ? 'white' : 'black',
            padding: '1px',
            marginRight: '4px',
          }}
        >
          Материали
          {open ? (
            <Chip
              style={{ fontSize, margin: '2px' }}
              avatar={<Remove />}
              onClick={() => setOpen(false)}
              clickable
            />
          ) : (
            <Chip
              style={{ fontSize, margin: '2px' }}
              avatar={<OpenWith />}
              onClick={() => setOpen(true)}
              clickable
            />
          )}
        </Typography>
        {taskStarted.started &&
          taskStarted.taskId === task.id &&
          !materialsDialog.open &&
          !task.appEnd && (
            <Chip
              style={{ margin: '1px', fontSize }}
              avatar={<Add />}
              onClick={() =>
                dispatch(
                  setMaterialsDialog({
                    open: true,
                    dataSet: 'materials',
                    checkout: true,
                    hideDismantledMaterials: true,
                  })
                )
              }
              clickable
              label="Добави"
            />
          )}
        {task.appEnd && !materialsDialog.open && (
          <Chip
            style={{ margin: '1px', fontSize }}
            avatar={<Add />}
            onClick={() =>
              dispatch(
                setMaterialsDialog({
                  open: true,
                  dataSet: 'materials',
                  checkout: true,
                  hideDismantledMaterials: true,
                })
              )
            }
            clickable
            label="Добави при вече затворена задача"
          />
        )}
      </div>
      {open && (
        <CardContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize }} size="small">
                  Име
                </TableCell>
                <TableCell style={{ fontSize }} size="small">
                  Сер. номер
                </TableCell>
                <TableCell style={{ fontSize }} size="small">
                  Кол.
                </TableCell>
                <TableCell style={{ fontSize }} size="small" />
              </TableRow>
            </TableHead>
            <TableBody>
              {usedMaterials &&
                usedMaterials
                  .filter(x => x.taskAddress === task.address && x.taskId === task.id)
                  .map(x => (
                    <TableRow key={x.serialNumber || x.materialId}>
                      <TableCell style={{ fontSize }} size="small">
                        {x.materialName}
                      </TableCell>
                      <TableCell style={{ fontSize }} size="small">
                        {x.serialNumber}
                      </TableCell>
                      <TableCell style={{ fontSize }} size="small">
                        {x.quantity}
                      </TableCell>
                      <TableCell style={{ fontSize }} size="small">
                        <IconButton
                          onClick={() => {
                            const updatedUsedMaterials = removeUsedMaterial(
                              x,
                              usedMaterials,
                              usedMaterialsListType,
                              data,
                              dispatch
                            );
                            deleteUsedMaterial(
                              x,
                              { ...data, usedMaterials: updatedUsedMaterials },
                              dispatch
                            );
                          }}
                        >
                          <Remove />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
            <TableBody>
              {newUsedMaterials
                .filter(x => x.taskAddress === task.address && x.taskId === task.id)
                .map(x => (
                  <TableRow key={x.serialNumber || x.materialId}>
                    <TableCell style={{ fontSize }} size="small">
                      {x.materialName}
                    </TableCell>
                    <TableCell style={{ fontSize }} size="small">
                      {x.serialNumber}
                    </TableCell>
                    <TableCell style={{ fontSize }} size="small">
                      {x.quantity}
                    </TableCell>
                    <TableCell style={{ fontSize }} size="small">
                      <IconButton
                        onClick={() => {
                          removeUsedMaterial(
                            x,
                            newUsedMaterials,
                            newUsedMaterialsListType,
                            undefined,
                            dispatch
                          );
                        }}
                      >
                        <Remove />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
            <TableBody>
              {closedTaskUsedMaterials
                .filter(x => x.taskAddress === task.address && x.taskId === task.id)
                .map(x => (
                  <TableRow key={x.serialNumber || x.materialId}>
                    <TableCell style={{ fontSize }} size="small">
                      {x.materialName}
                    </TableCell>
                    <TableCell style={{ fontSize }} size="small">
                      {x.serialNumber}
                    </TableCell>
                    <TableCell style={{ fontSize }} size="small">
                      {x.quantity}
                    </TableCell>
                    <TableCell style={{ fontSize }} size="small">
                      <IconButton
                        onClick={() => {
                          const updatedUsedMaterials = removeUsedMaterial(
                            x,
                            closedTaskUsedMaterials,
                            closedTaskUsedMaterialsListType,
                            undefined,
                            dispatch
                          );

                          !materialsDialog.open &&
                            deleteUsedMaterial(
                              x,
                              { ...data, usedMaterials: updatedUsedMaterials },
                              dispatch
                            );
                        }}
                      >
                        <Remove />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </CardContent>
      )}
    </Card>
  ) : null;
};
